<div class="bg-default content-height pb-3 m-1">
  <div class="flex justify-content-between align-items-center title-bg title-case">
    <div class="conten">
      <div class="btn"><a>TeleCare Platform Privacy Policy</a></div>
    </div>
  </div>
  <div class="md:col-12">
    <div class="Terms-data pl-5 pr-5">
      <h2>
        Effective: July 14, 2021
      </h2>

      <p>
        Your (“you” or “your”) privacy is important to TeleSpecialists, acting on behalf of its subsidiaries,
        affiliates, and licensors, (“TeleSpecialists”, “we”, or “us”) and we are committed to protecting the
        privacy of visitors to the TeleCare Platform. The purpose of this privacy policy (“Policy”) is to let
        you know how TeleSpecialists collects, protects, shares, and controls information received from
        you via the TeleCare mobile app, TeleSpecialists’ TeleCare website and/or members-only
        website (collectively, the “TeleCare Platform” or the “Platform“), as well as inform you of the
        risks involved when you communicate or provide information through the Internet.
        This Policy applies only to the Platform located here <a href="https://tstelecare.com"
          target="_blank">tstelecare.com</a> and provides
        you information on the personal information that TeleSpecialists may collect from you via the
        Platform and how we may use it, whether you are using the Platform as a customer, hospital
        staff member, TeleSpecialists employee, patient (or a patient’s legal representative) or a
        physician. TeleSpecialists’ Terms of Use and Terms of Service do not apply to your use of the
        Platform.
      </p>
      <p>
        TeleSpecialists and the health care providers providing services via this Platform are HIPAA
        Covered Entities. Our access, use, and disclosure of any protected health information (“PHI”) is
        governed by our HIPAA Policies and Notice of Privacy Practices.
        This Policy may be updated or changed from time to time. By continuing to use this Platform,
        you consent to the Policy as well as the TeleCare Platform Terms of Use.
      </p>

      <h2>
        The Personal Information We Collect from You
      </h2>

      <h4>
        Personally Identifiable Information
      </h4>

      <p>
        The personally identifiable information you provide to us or we may receive through the Platform
        includes information about your computer, your internet service provider, the browser you are
        using, and your internet address (“Personal Information.”) We may use cookies, which are small
        pieces of computer code that allow us to recognize you when you visit the Platform. We may
        collect information that personally identifies you when you choose to provide it to us, such as
        when you log in to the Platform. The Personal Information you submit is shared only with those
        people within our organization who need this information to respond to your questions or
        requests, third parties who provide services for you on our behalf (such as payment
        processors), and as otherwise permitted by law to allow us to operate our business or to comply
        with applicable laws.
      </p>

      <h4>
        The Information We Collect From You
      </h4>

      <p>
        For various purposes, we may collect Personal Information that may or may not personally
        identify you, such as Platform usage, traffic patterns, site performance and related statistics
        based on our tracking record of your visits to our Platform. We may collect some of this
        information using persistent “cookies” to recognize a repeat visitor; this helps us collect general
        information about how our site is viewed. We may also collect and log the IP address of each
        visitor to gather aggregate data on visitors to our Platform.
      </p>

      <h4>
        Cookies
      </h4>

      <p>
        Like many companies, we may use “cookie” technology on and off of the Platform. “Cookies”
        are text files with a small amount of information that are sent to your browser and transferred to
        you on your computer’s hard drive. The cookies do not contain any identifiable health
        information and cannot profile your system or collect information from your hard drive.
      </p>

      <p>
        The “help” portion of the toolbar on most browsers will tell you how to prevent your browser from
        accepting certain types of cookies, how to have the browser notify you when you receive a new
        cookie, or how to disable cookies altogether. Please note that disabling cookies may prevent
        you from using and accessing this Platform. In addition, if you visit our Platform again after
        deleting a cookie, a new cookie may be activated.
      </p>

      <p>
        Since third parties may use their own cookies when you click on a hypertext link to their site or
        service, you should carefully review the privacy policy of other sites you link to from our
        Platform.
      </p>

      <h4>
        IP Addresses
      </h4>

      <p>
        We may also log and track IP addresses for systems administration purposes and for reporting
        usage trends. Your IP address is usually associated with the physical place from which you
        enter the Internet, the name of the domain and host from which you access the Internet, the
        browser software you use and your operating system, and may also depend on the date and
        time you access the Platform. By collecting your IP address, we may record the page that linked
        you to this Platform, the web pages you visit, the ads you see or click on, and other information
        about the type of web browser, computer, platform and settings you are using, and any search
        terms you enter on this Platform. IP addresses are not used to track an individual user’s
        session. This information only helps us determine how often different areas of our Platform is
        visited.
      </p>

      <p>
        We may combine non-identifiable information collected automatically (such as through IP
        addresses, cookies or click-stream monitoring) with any previously submitted personal
        information that we may have received from you.
      </p>

      <h4>
        Geographic Location
      </h4>

      <p>
        We may collect your geographic location based on your IP address and other location-based
        data. However, we do not collect any device identifications.
      </p>

      <h4>
        Analytics
      </h4>

      <p>
        We may also use Google Analytics to collect, track and analyze track analytical data regarding
        Website usage and trends.
      </p>

      <h4>
        Using Your Personal Information
      </h4>

      <p>
        We will not sell, share or rent the information that is collected via the Platform to others in ways
        that differ from what is disclosed in this Policy. We also reserve the right to share Personal
        Information collected from this Platform with third parties to the extent permitted by applicable
        law.
      </p>

      <p>
        TeleSpecialists maintains full rights to any information collected on this Platform, and may freely
        collect, use and disclose such information unless prohibited by this Policy or applicable law.
      </p>

      <p>
        We use your Personal Information to operate and administer the Platform to make it as helpful
        as possible to you, inform you of services available from us, assist you and help us perform our
        responsibilities to you, or for any other purpose disclosed by us when you provide your Personal
        Information.
      </p>

      <p>
        We will disclose Personal Information when compelled to do so by law, including pursuant to
        subpoena, as well as when authorized by law at the request of law enforcement or to protect the
        security or integrity of the Platform. We may also disclose Personal Information if we believe it is
        appropriate to do so to protect you or another person from harm.
      </p>

      <p>
        We do not share Personal Information with any other third parties except as described in this
        Policy. We do not sell Personal Information, nor do we share or disclose Personal Information to
        any third parties for any marketing or advertising purposes.
      </p>

      <h4>
        Transfer of Data
      </h4>

      <p>
        In the event of a change in control of TeleSpecialists or sale by TeleSpecialists of substantially
        all of its assets or other acquisition, sale, merger or reorganization, any information owned by or
        in the control of TeleSpecialists may be transferred and/or sold to such TeleSpecialists
        successor, who will comply with the terms of this Privacy Policy.
      </p>

      <h4>
        Email
      </h4>

      <p>
        Most email does not provide a completely secure and confidential means of communication and
        is not encrypted. This means it is possible that your email could be intercepted and viewed
        inappropriately by or disclosed to another Internet user or unauthorized party. If you choose to
        provide us with your email address or to send us information using email, you accept the risks
        that may result from others intercepting, altering, forwarding or using the information without
        authorization. If you wish to keep your information completely private, you should not use email.
        By providing your email address to us and agreeing to the terms of this Policy, you are
        indicating that you wish to accept the risk and are consenting to allow us to communicate with
        you by email.
      </p>

      <p>
        From time to time, a representative from TeleSpecialists may wish to deliver information to you
        via email. In addition, TeleSpecialists may occasionally distribute news and announcements via email. We do not
        sell, trade, or otherwise share our email lists with others. You may remove
        your name from any list you have registered for using our Platform’s established method. With
        regard to your use of email, we warn that:
      </p>

      <p>
        If you receive email at work, your employer may have the right to save and read your email;
        similarly, your Internet service provider may have the right to save and read your email.
      </p>

      <p>
        If you share your email account, others may view your emails.
      </p>

      <p>
        It is possible to intercept and read email during transmission.
      </p>

      <h4>
        Security
      </h4>

      <p>
        You should be aware that no transmission of information over the Internet or any wireless
        network can be guaranteed to be 100% secure. We maintain reasonable, commercially
        acceptable physical, administrative, electronic, technical and procedural safeguards to help
        protect your Personal Information collected via the Platform as required by applicable law. While
        we cannot guarantee that loss, misuse or alteration to data will not occur, we use industry
        standards, such as Secure Socket Layers (“SSL”) technology, to help safeguard against such
        occurrences. In certain areas, the information passed between your browser and our system is
        encrypted with SSL technology to create a protected connection between you and our website
        to ensure confidentiality. However, information you submit through your computer or mobile
        device may not have the same security as our computers. We limit access to personally
        identifiable information about you to our employees and third-party agents, who we reasonably
        believe need to have access to your information to provide you with the information or services
        you request via the Platform.
      </p>

      <p>
        In the event that a breach in our security systems occurs and there is a possibility that an
        unauthorized person acquires your personal information, we will notify you of such a breach as
        may be required by applicable law.
      </p>

      <p>
        In order to help maintain security, you should never share your user ID or password and should
        always sign out when you are finished using the Platform.
      </p>

      <p>
        We use reasonable efforts to keep the Platform and your Personal Information safe and secure,
        but you are still using the Platform at your own risk. Safety and security issues could arise from
        the Platform or your personal computer, mobile device, or browser. We are not responsible for
        the actions, content, information, or data of third parties, and you release us, our directors,
        officers, employees, and agents from any claims and damages, known and unknown, arising
        out of or in any way connected with any claim you have against any such third parties.
      </p>

      <h4>
        Access
      </h4>

      <p>
        We will maintain your information and allow you to request updates at any time by logging into
        your Platform account to access your information. We will also take steps to make sure that any
        updates that you provide are processed in a timely and complete manner.
      </p>

      <h4>
        Third Party Websites
      </h4>

      <p>
        Some portions of the Platform may be provided in cooperation with third parties (“Third Party
        Pages”) or are provided by third parties (“Third Party Platforms”) and as a result have terms of
        use that are different from the TeleCare Platform Terms of Use, TeleCare Platform Privacy
        Policy, and HIPAA Notice of Privacy Practices, as applicable. If you choose to access such
        sites, you are subject to the privacy policies of those sites. If you use the Platform to link to
        another web site, which is not controlled or maintained by TeleSpecialists, you may decide to
        disclose personal information at that web site. For example, you might provide your contact
        information to obtain an information packet from an organization. Please be aware that in
        contacting that site, or in providing information on that site, that third party may obtain personal
        information about you. We encourage you to be aware when you leave our Platform and to read
        the privacy statements of each and every site that collects personally identifiable information.
      </p>

      <h4>
        Important Note Regarding Children
      </h4>

      <p>
        This Platform is not directed toward children under 18 years of age and TeleSpecialists does not
        knowingly collect information from children under 18 through the Platform. We comply with the
        Children’s Online Privacy Protection Act (“COPPA”), so we do not knowingly allow anyone
        Platform under the age of thirteen (13) to submit personally identifiable information on the
        Platform. If you think we have collected personal information from a child under the age of 13
        through this Platform, please contact us immediately.
      </p>

      <h4>
        California
      </h4>

      <p>
        Under California Civil Code Section 1798.83, California residents have the right to request from
        a business any personal information that a business may have shared with a third party for
        direct marketing purposes. We do not share Personal Information with any third party for direct
        marketing purposes. The California Online Privacy Protection Act (“CalOPPA”) requires us to
        disclose how we respond to Do Not Track signals set in a user’s browser. The following is
        information about how we respond to Do Not Track.
      </p>

      <p>
        Internet browsers generally offer a Do Not Track option that relies on technology known as a Do
        Not Track header that sends a signal to the Platforms that a user visits to tell the Platform about
        that user’s Do Not Track preference. You can usually access your browser’s Do Not Track
        option in your browser’s preferences. There is currently no industry standard for Do Not Track
        technology and we are not able to support Do Not Track preferences.
      </p>

      <h4>
        Contact TeleSpecialists
      </h4>

      <p>
        The Platform is owned and operated by TeleSpecialists, LLC. If you have any questions
        about this Privacy Policy or the use of your information by TeleSpecialists please
        contact us at:
      </p>

      <p class="mb-0">TeleSpecialists, LLC</p>
      <address class="mb-0">
        Attn: Legal Department <br>
        9110 College Pointe Ct<br>
        Example.com<br>
        Fort Myers, FL 33914
      </address>
      <a href="mailto:telecaresupport@tstelemed.com">telecaresupport@tstelemed.com</a>
    </div>
  </div>
</div>
